var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'inline-flex bg-badge px-2 p-1 rounded-full leading-none items-center justify-center text-white',
    { 'hover:cursor-pointer': _vm.deleteable }
  ],on:{"click":() => (_vm.deleteable ? _vm.$emit('delete') : null)}},[_vm._t("default"),(_vm.deleteable)?_c('div',{staticClass:"ml-1 -mr-2"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'times-circle']}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }